module.exports = __webpack_public_path__ + "img/arrow_down.d1331e25.svg";